/*
 * Approved copy constants for the Governance Tile numbers-reconcile block.
 *
 * Every string is word-for-word from mockup v8.8.12 lines 667-672 and
 * carries the operator's [COPY-APPROVED: governance-tile-v8] token
 * (2026-07-24).
 *
 * Static mockup denominators (`48 task-equivalent turns`, `25 of 48`,
 * `7 of 48`, `18 of 48`, `0 of 48`) and last-session-specific
 * reconciliation prose (Tile A/B/C cross-references, IJ-018 anchor
 * text, IJ-046 rescale mention, 2026-07-21 fork stamp) are stripped
 * — every itemised line is now resolved live in NumbersReconcile.jsx
 * from the summary endpoint, or renders an em dash with a `-pending`
 * testid marker when either operand is unmeasured (attestation-
 * honesty rule · anchor GB-013).
 */

export const RECONCILE_HEADLINE =
  'How the numbers reconcile · this session';

// Live-computed body sentence.  Prefix + suffix wrap the live
// tasks_total value; when tasks_total is null the body collapses to
// the "no turns logged" state.
export const RECONCILE_BODY_PREFIX = 'This session has run ';
export const RECONCILE_BODY_SUFFIX = ' task-equivalent turns so far.';
export const RECONCILE_BODY_ZERO = 'This session has not logged its first task yet.';

// Item schema: each item exposes `key` (stable test id suffix), `rest`
// (the semantic label that follows the live "X of Y" strong span),
// and `extract(summary)` returning `{ numerator, denominator }` or
// `null` when either operand is not emitted by the endpoint.
export const RECONCILE_ITEMS = [
  {
    key: 'operator-catches',
    rest: 'you caught wrong.',
    extract: (s) => {
      const num = s.got_wrong;
      const den = s.tasks_total;
      if (num === null || num === undefined) return null;
      if (den === null || den === undefined) return null;
      return { numerator: num, denominator: den };
    },
  },
  {
    key: 'judge-substantive',
    rest: 'the Judge produced a substantive Judgement on.',
    extract: (s) => {
      const num = s.judge_proactive_catches;
      const den = s.tasks_total;
      if (num === null || num === undefined) return null;
      if (den === null || den === undefined) return null;
      return { numerator: num, denominator: den };
    },
  },
  {
    key: 'judge-missed',
    rest: 'the Judge missed entirely — no Judgement ran.',
    extract: (s) => {
      const clean = s.judge_proactive_catches;
      const den = s.tasks_total;
      if (clean === null || clean === undefined) return null;
      if (den === null || den === undefined) return null;
      const missed = Math.max(den - clean, 0);
      return { numerator: missed, denominator: den };
    },
  },
  {
    key: 'right-first-time',
    rest: 'confirmed right first time.',
    extract: (s) => {
      const num = s.right_first_time;
      const den = s.tasks_total;
      if (num === null || num === undefined) return null;
      if (den === null || den === undefined) return null;
      return { numerator: num, denominator: den };
    },
  },
];
